import clsx from "clsx";

export const Input: React.FC<React.ComponentProps<"input">> = ({
  className,
  ...props
}) => {
  return (
    <input
      className={clsx(
        "input input-bordered group-aria-[invalid=true]/form-control:input-error",
        className,
      )}
      {...props}
    />
  );
};
